import type { PaymentRuntimePayload } from "../gateway/payment-runtime-client";
import { posRuntimeDb } from "./pos-db";
import type { TrustedTerminalIdentity } from "./terminal-state";

const paymentDomain = "PAYMENT_RUNTIME";

export type LocalPaymentRuntime = {
  initialized: boolean;
  payload: PaymentRuntimePayload | null;
};

function paymentScope(identity: TrustedTerminalIdentity) {
  return `org:${identity.organization_id}:branch:${identity.branch_id}:channel:${identity.commerce_channel_id}:node:${identity.node_id}:payment`;
}

function paymentProjectionKey(identity: TrustedTerminalIdentity) {
  return `payment:${paymentScope(identity)}`;
}

export async function readPaymentRuntime(identity: TrustedTerminalIdentity): Promise<LocalPaymentRuntime> {
  const row = await posRuntimeDb.projections.get(paymentProjectionKey(identity));
  if (!row || row.domain !== paymentDomain || !row.payload || typeof row.payload !== "object") {
    return { initialized: false, payload: null };
  }
  return { initialized: true, payload: row.payload as PaymentRuntimePayload };
}

export async function applyPaymentRuntimePayload(
  identity: TrustedTerminalIdentity,
  payload: PaymentRuntimePayload,
) {
  const now = new Date().toISOString();
  await posRuntimeDb.projections.put({
    key: paymentProjectionKey(identity),
    scopeKey: paymentScope(identity),
    domain: paymentDomain,
    revision: payload.generated_at,
    payload,
    updatedAt: now,
  });
  return payload;
}
